import { Vector as VectorLayer } from 'ol/layer'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { Style, Fill, Stroke } from 'ol/style'

export function createGeoJsonLayer(
  geojson: any,
  name = 'GEOJSON_LAYER',
  options?: {
    strokeColor?: string
    fillColor?: string
    strokeWidth?: number
    zIndex?: number
  }
) {
  const { strokeColor = 'red', fillColor = 'rgba(255, 0, 0, 0.2)', strokeWidth = 2, zIndex = 10 } = options || {}

  const source = new VectorSource({
    features: new GeoJSON().readFeatures(geojson, {
      featureProjection: 'EPSG:3857',
    }),
  })

  const style = new Style({
    stroke: new Stroke({
      color: strokeColor,
      width: strokeWidth,
    }),
    fill: new Fill({
      color: fillColor,
    }),
  })

  const layer = new VectorLayer({
    source,
    style,
  })

  layer.set('name', name)
  layer.setZIndex(zIndex)

  return layer
}
